

var htmlLatexRender = function () {
    function r(f) {
      return Math.max(f.clientHeight, f.scrollHeight)
    }

    function t(f, h) {
      return 1 != f.nodeType ? null : f.getAttribute(h)
    }

    function p(f, h, l) {
      switch (typeof h) {
        case "object":
          for (var b in h) f.style[b] = h[b];
          break;
        case "string":
          f.style[h] = l
      }
    }

    function e(f, h) {
      if (null == f) return null;
      try {
        if (!0 == h) {
          var l = f.parentNode;
          if (l.nextElementSibling) return l.nextElementSibling;
          for (; l = l.nextSibling;)
            if (1 == l.nodeType) return l
        } else {
          if (f.nextElementSibling) return f.nextElementSibling;
          for (; f =
            f.nextSibling;)
            if (1 == f.nodeType) return f
        }
      } catch (b) {}
      return null
    }

    function n(f, h, l, b) {
      if (null != f) {
        ++b;
        for (var e = f.children || f.childNodes, p = 0; p < e.length; p++) f = e[p], 1 == f.nodeType && (l(f) && h.push({
          n: f,
          d: b
        }), n(f, h, l, b))
      }
    }

    function s(f) {
      var h = [],
        e = 0;
      n(f, h, function (b) {
        if (t(b, "hassize")) return !0
      }, 0);
      for (e = 0; e < h.length; e++) h[e].h = r(h[e].n.parentNode), h[e].w = Math.max(h[e].n.parentNode.clientWidth, h[e].n.parentNode.scrollWidth), h[e].s = parseInt(t(h[e].n, "hassize")), h[e].f = t(h[e].n, "dealflag");
      for (e = 0; e < h.length; e++)
        if (0 >
          h[e].s) switch (f = t(h[e].n, "mathtag"), f) {
          case "msup_sup":
            F(h[e]);
            break;
          case "msub_sub":
            z(h[e]);
            break;
          case "msubsup_sup":
            v(h[e])
        } else u(h[e])
    }

    function u(f) {
      var e = [],
        l;
      n(f.n, e, function (b) {
        if (t(b, "muststretch")) return !0
      }, 0);
      if (!(1 > e.length))
        if (l = t(e[0].n, "muststretch"), "v" == l) {
          if (l = (f.h - f.s) / e.length, 0 < l)
            for (f = 0; f < e.length; f++) e[f].n.style.height = l + "px"
        } else if (l = (f.w - f.s) / e.length, 0 < l)
        for (f = 0; f < e.length; f++) e[f].n.style.width = l + "px"
    }

    function v(f) {
      var h = e(f.n),
        l = r(f.n),
        b = r(h),
        f = f.h - (l + b);
      0 < f && p(h, "marginTop",
        f + "px")
    }

    function F(e) {
      if (e.f) {
        var h = r(e.n.parentNode);
        0 < h && p(e.n, "verticalAlign", 3 * h / 4 + "px")
      }
    }

    function z(e) {
      e.f && 0 < r(e.n.parentNode) && p(e.n, "verticalAlign", "-100%")
    }

    function w(e) {
      if (!(null == e || 8 == e.nodeType || 1 > e.childNodes.length || /input|form|math|iframe|textarea|pre|svg/.test(e.nodeName)))
        for (var h, l, b, k, n = e.childNodes.length - 1; - 1 < n; n--)
          if (3 != e.childNodes[n].nodeType) w(e.childNodes[n]);
          else {
            h = e.childNodes[n].nodeValue.replace(/sin/g, "\u253d").replace(/cos/g, "\u253e").replace(/tan/g, "\u253f").replace(/lim/g,
              "\u2540");
            h = h.replace(/\-/g, "\u2212").replace(/=/g, "\uff1d").replace(/\\+/g, "\uff0b");
            l = document.createDocumentFragment();
            for (var p = 0; p < h.length; p++) {
              k = h.charAt(p);
              switch (k) {
                case "\u253d":
                  k = "sin";
                  break;
                case "\u253e":
                  k = "cos";
                  break;
                case "\u253f":
                  k = "tan";
                  break;
                case "\u2540":
                  k = "lim";
                  break;
                default:
                  if (/[a-z]/i.test(k)) {
                    b = document.createElement("font");
                    b.className = "MathJye_mi";
                    b.appendChild(document.createTextNode(k));
                    l.appendChild(b);
                    continue
                  }
              }
              l.appendChild(document.createTextNode(k))
            }
            e.replaceChild(l,
              e.childNodes[n])
          }
    }
    this.LayOut = function (e) {
      for (var e = e.getElementsByTagName("span"), h = 0; h < e.length; h++) "math" == t(e[h], "mathtag") && (w(e[h]), 1 == t(e[h], "dealflag") && s(e[h]))
    }
  },
  BrowserIS = {
    isMSIE: null != window.ActiveXObject && null != window.clipboardData,
    isFirefox: null != window.netscape && null != document.ATTRIBUTE_NODE && !window.opera,
    isSafari: null != navigator.userAgent.match(/ (Apple)?WebKit\//) && (!window.chrome || null == window.chrome.loadTimes),
    isChrome: null != window.chrome && null != window.chrome.loadTimes,
    isOpera: null !=
      window.opera && null != window.opera.version,
    isQQ: null != navigator.userAgent.match(/QQBrowser|Tencent/i),
    is360: null != navigator.userAgent.match(/360se|360ee/i),
    isSogou: null != navigator.userAgent.match(/MetaSr/i)
  };

function mathPlayerActivex() {
  try {
    return new ActiveXObject("MathPlayer.Factory.1")
  } catch (r) {}
  return null
}

function gumlActivex() {
  try {
    return new ActiveXObject("GUML.Face")
  } catch (r) {}
  return null
}
var hasGUML = null != window.ActiveXObject && null != gumlActivex(),
  hasMathPlayer = null != window.ActiveXObject && null != mathPlayerActivex(),
  isIE = BrowserIS.isMSIE,
  LatexPageRender = function () {
    function r(c, a) {
      return c.input > a.input ? 1 : -1
    }

    function t(c) {
      return isIE ? document.createElement(c) : document.createElementNS("http://www.w3.org/1999/xhtml", c)
    }

    function p(c) {
      return isIE ? document.createElement("m:" + c) : document.createElementNS(f, c)
    }

    function e(c, a) {
      var g = isIE ? document.createElement("m:" + c) : document.createElementNS(f,
        c);
      g.appendChild(a);
      return g
    }

    function n(c, a) {
      for (var g = c.slice(a), d = 0; d < g.length && 32 >= g.charCodeAt(d); d += 1);
      return g.slice(d)
    }

    function s(c) {
      var a = 0,
        g = 0,
        d, j, e = "";
      j = !0;
      for (var f = 1; f <= c.length && j; f++) {
        j = c.slice(0, f);
        g = a;
        a = g;
        if (0 == a) {
          for (var h = g = void 0, a = -1, g = q.length; a + 1 < g;) h = a + g >> 1, q[h] < j ? a = h : g = h;
          a = g
        } else
          for (; a < q.length && q[a] < j; a++);
        a < q.length && c.slice(0, q[a].length) == q[a] && (e = q[a], d = a, f = e.length);
        j = a < q.length && c.slice(0, q[a].length) >= q[a]
      }
      if ("" != e) return G[d];
      j = c.slice(0, 1);
      return {
        input: j,
        tag: "0" <=
          j && "9" >= j ? "mn" : ("A" > j || "Z" < j) && ("a" > j || "z" < j) ? "mo" : "mi",
        output: j,
        ttype: b
      }
    }

    function u(c) {
      var a, g, d, j, f, h = document.createDocumentFragment(),
        c = n(c, 0);
      a = s(c);
      if (null == a || a.ttype == B || a.ttype == D && (c = a.output + n(c, a.input.length), a = s(c), null == a || a.ttype == B)) return [null, c, null];
      c = n(c, a.input.length);
      switch (a.ttype) {
        case x:
          return g = p(a.tag), g.setAttribute(a.atname, a.atval), [g, c, a.tag];
        case m:
          return isIE && "\\big" == a.input.substr(0, 4) && (c = "\\" + a.input.substr(4) + c, a = s(c), a.ttype = m, c = n(c, a.input.length)), [e(a.tag,
            document.createTextNode(a.output)), c, a.tag];
        case b:
          j = a.output;
          if (isIE)
            if ("'" == a.input) j = "\u2032";
            else if ("''" == a.input) j = "\u2033";
          else if ("'''" == a.input) j = "\u2033\u2032";
          else if ("''''" == a.input) j = "\u2033\u2033";
          else if ("\\square" == a.input) j = "\u25a1";
          else if ("\\frac" == a.input.substr(0, 5) && (d = a.input.substr(6, 1), "5" == d || "6" == d)) return c = a.input.replace(/\\frac/, "\\frac ") + c, [g, c, a.tag];
          g = e(a.tag, document.createTextNode(j));
          return [g, c, a.tag];
        case y:
          return g = e(a.tag, document.createTextNode(a.output)),
            g.setAttribute("minsize", "1.5"), g.setAttribute("maxsize", "1.5"), g = e("mover", g), g.appendChild(p("mspace")), [g, c, a.tag];
        case o:
          isIE && "\\backslash" == a.input && (a.output = "\\");
          g = e(a.tag, document.createTextNode(a.output));
          if ("|" == a.input || "\\vert" == a.input || "\\|" == a.input || "\\Vert" == a.input) g.setAttribute("lspace", "0em"), g.setAttribute("rspace", "0em");
          g.setAttribute("maxsize", a.atval);
          return null != a.rtag ? [g, c, a.rtag] : [g, c, a.tag];
        case E:
          d = a.atval;
          isIE && (d = a.ieval);
          a = s(c);
          if (null == a) return [null, c, null];
          c =
            n(c, a.input.length);
          g = e(a.tag, document.createTextNode(a.output));
          isIE ? (j = p("mspace"), j.setAttribute("height", d + "ex"), g = e("mrow", g), g.appendChild(j)) : (g.setAttribute("minsize", d), g.setAttribute("maxsize", d));
          return [g, c, a.tag];
        case H:
          return "\\left" == a.input && (a = s(c), null != a && ("." == a.input && (a.invisible = !0), c = n(c, a.input.length))), d = v(c, !0, !1), null == a || "boolean" == typeof a.invisible && a.invisible ? g = e("mrow", d[0]) : (g = e("mo", document.createTextNode(a.output)), g = e("mrow", g), g.appendChild(d[0])), [g, d[1], d[2]];
        case K:
          d = v(c, !0, !1);
          null != d[0].lastChild && (f = d[0].lastChild.firstChild.nodeValue);
          if ("|" == f) return g = e("mo", document.createTextNode(a.output)), g = e("mrow", g), g.appendChild(d[0]), [g, d[1], null];
          g = e("mo", document.createTextNode(a.output));
          g = e("mrow", g);
          return [g, c, null];
        case I:
          if ("\\begin{array}" == a.input) {
            j = "";
            a = s(c);
            c = n(c, 0);
            if (null == a) j = "l";
            else if (c = n(c, a.input.length), "{" != a.input) j = "l";
            else {
              do a = s(c), null != a && (c = n(c, a.input.length), "}" != a.input && (j += a.input)); while (null != a && "" != a.input && "}" != a.input)
            }
            d = v("{" + c, !0, !0);
            g = e("mtable", d[0]);
            j = j.replace(/l/g, "left ");
            j = j.replace(/r/g, "right ");
            j = j.replace(/c/g, "center ");
            g.setAttribute("columnalign", j);
            g.setAttribute("displaystyle", "false")
          } else d = v("{" + c, !0, !0), g = e("mtable", d[0]), isIE ? g.setAttribute("columnspacing", "0.25em") : g.setAttribute("columnspacing", "0.167em"), g.setAttribute("columnalign", "right center left"), g.setAttribute("displaystyle", "true"), g = e("mrow", g);
          return [g, d[1], null];
        case J:
          return j = "{" == c.charAt(0) ? c.indexOf("}") : 0, -1 == j && (j = c.length),
            f = c.slice(1, j), " " == f.charAt(0) && (g = p("mspace"), g.setAttribute("width", "0.33em"), h.appendChild(g)), h.appendChild(e(a.tag, document.createTextNode(f))), " " == f.charAt(f.length - 1) && (g = p("mspace"), g.setAttribute("width", "0.33em"), h.appendChild(g)), c = n(c, j + 1), [e("mrow", h), c, null];
        case k:
          d = u(c);
          if (null == d[0]) return [e(a.tag, document.createTextNode(a.output)), c];
          if ("boolean" == typeof a.func && a.func) {
            f = c.charAt(0);
            if ("^" == f || "_" == f || "," == f) return [e(a.tag, document.createTextNode(a.output)), c, a.tag];
            g = e("mrow",
              e(a.tag, document.createTextNode(a.output)));
            isIE && (j = p("mspace"), j.setAttribute("width", "0.167em"), g.appendChild(j));
            g.appendChild(d[0]);
            return [g, d[1], a.tag]
          }
          if ("\\sqrt" == a.input) return isIE ? (j = p("mspace"), j.setAttribute("height", "1.2ex"), j.setAttribute("width", "0em"), g = e(a.tag, d[0]), g.appendChild(j), [g, d[1], a.tag]) : [e(a.tag, d[0]), d[1], a.tag];
          if ("boolean" == typeof a.acc && a.acc) {
            if (g = e(a.tag, d[0]), j = a.output, isIE && ("\\hat" == a.input ? j = "\u0302" : "\\widehat" == a.input ? j = "^" : "\\bar" == a.input ? j = "\u00af" : "\\grave" ==
                a.input ? j = "\u0300" : "\\tilde" == a.input && (j = "\u0303")), c = e("mo", document.createTextNode(j)), "\\check" == a.input && c.setAttribute("maxsize", "1.2"), isIE && "\\bar" == a.input && c.setAttribute("maxsize", "0.5"), "\\underbrace" == a.input || "\\underline" == a.input || "\\underleftarrow" == a.input || "\\underrightarrow" == a.input ? c.setAttribute("accentunder", "true") : c.setAttribute("accent", "true"), g.appendChild(c), "\\overbrace" == a.input || "\\underbrace" == a.input) g.ttype = m
          } else {
            if (!isIE && "undefined" != typeof a.codes)
              for (j = 0; j <
                d[0].childNodes.length; j++)
                if ("mi" == d[0].childNodes[j].nodeName || "mi" == d[0].nodeName) {
                  f = "mi" == d[0].nodeName ? d[0].firstChild.nodeValue : d[0].childNodes[j].firstChild.nodeValue;
                  c = [];
                  for (g = 0; g < f.length; g++) c = 64 < f.charCodeAt(g) && 91 > f.charCodeAt(g) ? c + String.fromCharCode(a.codes[f.charCodeAt(g) - 65]) : c + f.charAt(g);
                  "mi" == d[0].nodeName ? d[0] = p("mo").appendChild(document.createTextNode(c)) : d[0].replaceChild(p("mo").appendChild(document.createTextNode(c)), d[0].childNodes[j])
                } g = e(a.tag, d[0]);
            g.setAttribute(a.atname,
              a.atval);
            ("\\scriptstyle" == a.input || "\\scriptscriptstyle" == a.input) && g.setAttribute("displaystyle", "false")
          }
          return [g, d[1], a.tag];
        case C:
          d = u(c);
          if (null == d[0]) return [e("mo", document.createTextNode(a.input)), c, null];
          g = u(d[1]);
          if (null == g[0]) return [e("mo", document.createTextNode(a.input)), c, null];
          ("\\root" == a.input || "\\stackrel" == a.input) && h.appendChild(g[0]);
          h.appendChild(d[0]);
          ("\\frac" == a.input || "\\underset" == a.input) && h.appendChild(g[0]);
          return [e(a.tag, h), g[1], a.tag];
        case A:
          return c = n(c, a.input.length),
            [e("mo", document.createTextNode(a.output)), c, a.tag];
        default:
          return [e(a.tag, document.createTextNode(a.output)), c, a.tag]
      }
    }

    function v(c, a, g) {
      var d, b, f, a = document.createDocumentFragment();
      do {
        var c = n(c, 0),
          h = void 0,
          k = void 0,
          l = void 0,
          k = f = d = b = void 0,
          c = n(c, 0),
          k = s(c);
        d = u(c);
        b = d[0];
        c = d[1];
        f = d[2];
        h = s(c);
        h.ttype == A && (c = n(c, h.input.length), d = u(c), null == d[0] && (d[0] = e("mo", document.createTextNode("\u25a1"))), c = d[1], f = d[2], "_" == h.input || "^" == h.input ? (l = s(c), f = null, k = k.ttype == m || b.ttype == m, "_" == h.input && "^" == l.input ?
          (c = n(c, l.input.length), h = u(c), c = h[1], f = h[2], b = e(k ? "munderover" : "msubsup", b), b.appendChild(d[0]), b.appendChild(h[0])) : (b = "_" == h.input ? e(k ? "munder" : "msub", b) : e(k ? "mover" : "msup", b), b.appendChild(d[0])), b = e("mrow", b)) : (b = e(h.tag, b), ("\\atop" == h.input || "\\choose" == h.input) && b.setAttribute("linethickness", "0ex"), b.appendChild(d[0]), "\\choose" == h.input && (b = e("mfenced", b))));
        d = [b, c, f];
        b = d[0];
        c = d[1];
        f = d[2];
        d = s(c);
        if (void 0 != b) {
          if (("mn" == f || "mi" == f) && null != d && "boolean" == typeof d.func && d.func) f = p("mspace"),
            f.setAttribute("width", "0.167em"), b = e("mrow", b), b.appendChild(f);
          a.appendChild(b)
        }
      } while (d.ttype != B && null != d && "" != d.output);
      f = null;
      if (d.ttype == B) {
        if ("\\right" == d.input && (c = n(c, d.input.length), d = s(c), null != d && "." == d.input && (d.invisible = !0), null != d)) f = d.rtag;
        null != d && (c = n(c, d.input.length));
        b = a.childNodes.length;
        if (g && 0 < b && "mrow" == a.childNodes[b - 1].nodeName && 1 < b && "mo" == a.childNodes[b - 2].nodeName && "&" == a.childNodes[b - 2].firstChild.nodeValue) {
          f = [];
          h = a.childNodes.length;
          for (d = 0; g && d < h; d += 2) {
            f[d] = [];
            b =
              a.childNodes[d];
            for (l = 0; l < b.childNodes.length; l++) b.childNodes[l].firstChild && "&" == b.childNodes[l].firstChild.nodeValue && (f[d][f[d].length] = l)
          }
          var o, q, r = document.createDocumentFragment();
          for (d = 0; d < h; d += 2) {
            g = document.createDocumentFragment();
            k = document.createDocumentFragment();
            b = a.firstChild;
            o = b.childNodes.length;
            for (l = q = 0; l < o; l++) "undefined" != typeof f[d][q] && l == f[d][q] ? (b.removeChild(b.firstChild), g.appendChild(e("mtd", k)), q++) : k.appendChild(b.firstChild);
            g.appendChild(e("mtd", k));
            2 < a.childNodes.length &&
              (a.removeChild(a.firstChild), a.removeChild(a.firstChild));
            r.appendChild(e("mtr", g))
          }
          return [r, c]
        }
        if ("boolean" != typeof d.invisible || !d.invisible) b = e("mo", document.createTextNode(d.output)), a.appendChild(b)
      }
      return [a, c, f]
    }

    function F(c) {
      c = c.replace(/^\$|\$$/g, "");
      c = c.replace(/^\s+/g, "");
      c = c.replace(/\uff08/g, "(");
      c = c.replace(/\uff09/g, ")");
      c = c.replace(/\\\\([\(\)\[\]\{\}])/g, "\\\\ $1");
      c = c.replace(/\{([\(\)\[\]])\}/g, "$1");
      c = c.replace(/\\(left|right)\s*([\[\]\(\)])/g, "$2");
      c = c.replace(/\\(left|right)\s*\\([\{\}])/g,
        "\\$2");
      c = c.replace(/\\{/g, "\\left\\{");
      c = c.replace(/\\}/g, "\\right\\}");
      c = c.replace(/\(/g, "\\left(");
      c = c.replace(/\)/g, "\\right)");
      c = c.replace(/\[/g, "\\left[");
      return c = c.replace(/\]/g, "\\right]")
    }

    function z(c, a) {
      if (!(null == c || 8 == c.nodeType || 1 > c.childNodes.length || /input|form|math|iframe|textarea|pre|svg/.test(c.nodeName) || "function" != typeof a))
        for (var b, d, e, f = c.childNodes.length - 1; - 1 < f; f--) 3 != c.childNodes[f].nodeType ? z(c.childNodes[f], a) : (b = c.childNodes[f].nodeValue, null == b || 0 > b.indexOf("$") || (e =
          0, b = b.replace(/\\\$/g, "\uffe6"), d = document.createDocumentFragment(), b.replace(/\$[\s\S]*?\$/ig, function (c, f) {
            e != f && 0 < f && d.appendChild(document.createTextNode(b.substr(e, f - e).replace(/\uffe6/g, "$")));
            d.appendChild(a(c.replace(/\uffe6/g, "$")));
            e = f + c.length;
            return c
          }), e != b.length && d.appendChild(document.createTextNode(b.substr(e).replace(/\uffe6/g, "$"))), c.replaceChild(d, c.childNodes[f])))
    }
    var w = this,
      f = "http://www.w3.org/1998/Math/MathML",
      h = {
        color: "#0000ff",
        fontsize: "13px",
        fontfamily: "arial",
        displaystyle: "true"
      },
      l = ["http://www.imathas.com/cgi-bin/mimetex.cgi?\\large ", "http://www.forkosh.dreamhost.com/cgi-bin/mimetex.cgi?\\large ", "http://www.mathtran.org/cgi-bin/mathtran?tex=\\large ", "http://cgi.jyeoo.net/mimetex.cgi?formdata=\\fs2+"],
      b = 0,
      k = 1,
      C = 2,
      A = 3,
      H = 4,
      B = 5,
      x = 6,
      m = 7,
      D = 8,
      J = 9,
      E = 10,
      y = 11,
      o = 12,
      I = 13,
      K = 14,
      G = [{
          input: "\\alpha",
          tag: "mi",
          output: "\u03b1",
          ttype: b
        }, {
          input: "\\beta",
          tag: "mi",
          output: "\u03b2",
          ttype: b
        }, {
          input: "\\gamma",
          tag: "mi",
          output: "\u03b3",
          ttype: b
        }, {
          input: "\\delta",
          tag: "mi",
          output: "\u03b4",
          ttype: b
        }, {
          input: "\\epsilon",
          tag: "mi",
          output: "\u03b5",
          ttype: b
        }, {
          input: "\\varepsilon",
          tag: "mi",
          output: "\u025b",
          ttype: b
        }, {
          input: "\\zeta",
          tag: "mi",
          output: "\u03b6",
          ttype: b
        }, {
          input: "\\eta",
          tag: "mi",
          output: "\u03b7",
          ttype: b
        }, {
          input: "\\theta",
          tag: "mi",
          output: "\u03b8",
          ttype: b
        }, {
          input: "\\vartheta",
          tag: "mi",
          output: "\u03d1",
          ttype: b
        }, {
          input: "\\iota",
          tag: "mi",
          output: "\u03b9",
          ttype: b
        }, {
          input: "\\kappa",
          tag: "mi",
          output: "\u03ba",
          ttype: b
        }, {
          input: "\\lambda",
          tag: "mi",
          output: "\u03bb",
          ttype: b
        }, {
          input: "\\mu",
          tag: "mi",
          output: "\u03bc",
          ttype: b
        }, {
          input: "\\nu",
          tag: "mi",
          output: "\u03bd",
          ttype: b
        }, {
          input: "\\xi",
          tag: "mi",
          output: "\u03be",
          ttype: b
        }, {
          input: "\\pi",
          tag: "mi",
          output: "\u03c0",
          ttype: b
        }, {
          input: "\\varpi",
          tag: "mi",
          output: "\u03d6",
          ttype: b
        }, {
          input: "\\rho",
          tag: "mi",
          output: "\u03c1",
          ttype: b
        }, {
          input: "\\varrho",
          tag: "mi",
          output: "\u03f1",
          ttype: b
        }, {
          input: "\\varsigma",
          tag: "mi",
          output: "\u03c2",
          ttype: b
        }, {
          input: "\\sigma",
          tag: "mi",
          output: "\u03c3",
          ttype: b
        }, {
          input: "\\tau",
          tag: "mi",
          output: "\u03c4",
          ttype: b
        }, {
          input: "\\upsilon",
          tag: "mi",
          output: "\u03c5",
          ttype: b
        }, {
          input: "\\phi",
          tag: "mi",
          output: "\u03c6",
          ttype: b
        }, {
          input: "\\varphi",
          tag: "mi",
          output: "\u03d5",
          ttype: b
        }, {
          input: "\\chi",
          tag: "mi",
          output: "\u03c7",
          ttype: b
        }, {
          input: "\\psi",
          tag: "mi",
          output: "\u03c8",
          ttype: b
        }, {
          input: "\\omega",
          tag: "mi",
          output: "\u03c9",
          ttype: b
        }, {
          input: "\\Gamma",
          tag: "mo",
          output: "\u0393",
          ttype: b
        }, {
          input: "\\Delta",
          tag: "mo",
          output: "\u0394",
          ttype: b
        }, {
          input: "\\Theta",
          tag: "mo",
          output: "\u0398",
          ttype: b
        }, {
          input: "\\Lambda",
          tag: "mo",
          output: "\u039b",
          ttype: b
        }, {
          input: "\\Xi",
          tag: "mo",
          output: "\u039e",
          ttype: b
        }, {
          input: "\\Pi",
          tag: "mo",
          output: "\u03a0",
          ttype: b
        }, {
          input: "\\Sigma",
          tag: "mo",
          output: "\u03a3",
          ttype: b
        }, {
          input: "\\Upsilon",
          tag: "mo",
          output: "\u03a5",
          ttype: b
        }, {
          input: "\\Phi",
          tag: "mo",
          output: "\u03a6",
          ttype: b
        }, {
          input: "\\Psi",
          tag: "mo",
          output: "\u03a8",
          ttype: b
        }, {
          input: "\\Omega",
          tag: "mo",
          output: "\u03a9",
          ttype: b
        }, {
          input: "\\pm",
          tag: "mo",
          output: "\u00b1",
          ttype: b
        }, {
          input: "\\mp",
          tag: "mo",
          output: "\u2213",
          ttype: b
        }, {
          input: "\\cdot",
          tag: "mo",
          output: "\u22c5",
          ttype: b
        }, {
          input: "\\star",
          tag: "mo",
          output: "\u22c6",
          ttype: b
        }, {
          input: "\\ast",
          tag: "mo",
          output: "*",
          ttype: b
        }, {
          input: "\\times",
          tag: "mo",
          output: "\u00d7",
          ttype: b
        }, {
          input: "\\div",
          tag: "mo",
          output: "\u00f7",
          ttype: b
        }, {
          input: "\\circ",
          tag: "mo",
          output: "\u2218",
          ttype: b
        }, {
          input: "\\bullet",
          tag: "mo",
          output: "\u2022",
          ttype: b
        }, {
          input: "\\oplus",
          tag: "mo",
          output: "\u2295",
          ttype: b
        }, {
          input: "\\ominus",
          tag: "mo",
          output: "\u2296",
          ttype: b
        }, {
          input: "\\otimes",
          tag: "mo",
          output: "\u2297",
          ttype: b
        }, {
          input: "\\odot",
          tag: "mo",
          output: "\u2299",
          ttype: b
        }, {
          input: "\\sum",
          tag: "mo",
          output: "\u2211",
          ttype: m
        }, {
          input: "\\prod",
          tag: "mo",
          output: "\u220f",
          ttype: m
        }, {
          input: "\\bigcap",
          tag: "mo",
          output: "\u22c2",
          ttype: m
        }, {
          input: "\\bigcup",
          tag: "mo",
          output: "\u22c3",
          ttype: m
        }, {
          input: "\\bigwedge",
          tag: "mo",
          output: "\u22c0",
          ttype: m
        }, {
          input: "\\bigvee",
          tag: "mo",
          output: "\u22c1",
          ttype: m
        }, {
          input: "\\bigsqcap",
          tag: "mo",
          output: "\u2a05",
          ttype: m
        }, {
          input: "\\bigsqcup",
          tag: "mo",
          output: "\u2a06",
          ttype: m
        }, {
          input: "\\coprod",
          tag: "mo",
          output: "\u2210",
          ttype: m
        }, {
          input: "\\bigoplus",
          tag: "mo",
          output: "\u2a01",
          ttype: m
        }, {
          input: "\\bigotimes",
          tag: "mo",
          output: "\u2a02",
          ttype: m
        },
        {
          input: "\\bigodot",
          tag: "mo",
          output: "\u2a00",
          ttype: m
        }, {
          input: "\\biguplus",
          tag: "mo",
          output: "\u2a04",
          ttype: m
        }, {
          input: "\\int",
          tag: "mo",
          output: "\u222b",
          ttype: b
        }, {
          input: "\u2192",
          tag: "mo",
          output: "\u2192",
          ttype: m
        }, {
          input: "\\xrightarrow",
          tag: "mo",
          output: "\u2192",
          ttype: m
        }, {
          input: "\u21cc",
          tag: "mo",
          output: "\u21cc",
          ttype: m
        }, {
          input: "\\rightleftharpoons",
          tag: "mo",
          output: "\u21cc",
          ttype: m
        }, {
          input: "\\_",
          tag: "mo",
          output: "_",
          ttype: b
        }, {
          input: "\\^",
          tag: "mo",
          output: "^",
          ttype: b
        }, {
          input: ":=",
          tag: "mo",
          output: ":=",
          ttype: b
        },
        {
          input: "\\lt",
          tag: "mo",
          output: "<",
          ttype: b
        }, {
          input: "\\gt",
          tag: "mo",
          output: ">",
          ttype: b
        }, {
          input: "\\ne",
          tag: "mo",
          output: "\u2260",
          ttype: b
        }, {
          input: "\\neq",
          tag: "mo",
          output: "\u2260",
          ttype: b
        }, {
          input: "\\le",
          tag: "mo",
          output: "\u2264",
          ttype: b
        }, {
          input: "\\leq",
          tag: "mo",
          output: "\u2264",
          ttype: b
        }, {
          input: "\\leqslant",
          tag: "mo",
          output: "\u2264",
          ttype: b
        }, {
          input: "\\ge",
          tag: "mo",
          output: "\u2265",
          ttype: b
        }, {
          input: "\\geq",
          tag: "mo",
          output: "\u2265",
          ttype: b
        }, {
          input: "\\geqslant",
          tag: "mo",
          output: "\u2265",
          ttype: b
        }, {
          input: "\\equiv",
          tag: "mo",
          output: "\u2261",
          ttype: b
        }, {
          input: "\\complement",
          tag: "mo",
          output: "\u2201",
          ttype: b
        }, {
          input: "\\begin{eqnarray}",
          output: "X",
          ttype: I,
          invisible: !0
        }, {
          input: "\\begin{array}",
          output: "X",
          ttype: I,
          invisible: !0
        }, {
          input: "\\\\",
          output: "}&{",
          ttype: D
        }, {
          input: "\\end{eqnarray}",
          output: "}}",
          ttype: D
        }, {
          input: "\\end{array}",
          output: "}}",
          ttype: D
        }, {
          input: "\\big",
          tag: "mo",
          output: "X",
          atval: "1.2",
          ieval: "2.2",
          ttype: E
        }, {
          input: "\\Big",
          tag: "mo",
          output: "X",
          atval: "1.6",
          ieval: "2.6",
          ttype: E
        }, {
          input: "\\bigg",
          tag: "mo",
          output: "X",
          atval: "2.2",
          ieval: "3.2",
          ttype: E
        }, {
          input: "\\Bigg",
          tag: "mo",
          output: "X",
          atval: "2.9",
          ieval: "3.9",
          ttype: E
        }, {
          input: "\\left",
          tag: "mo",
          output: "X",
          ttype: H
        }, {
          input: "\\right",
          tag: "mo",
          output: "X",
          ttype: B
        }, {
          input: "{",
          output: "{",
          ttype: H,
          invisible: !0
        }, {
          input: "}",
          output: "}",
          ttype: B,
          invisible: !0
        }, {
          input: "(",
          tag: "mo",
          output: "(",
          atval: "1",
          ttype: o
        }, {
          input: "[",
          tag: "mo",
          output: "[",
          atval: "1",
          ttype: o
        }, {
          input: "\\lbrack",
          tag: "mo",
          output: "[",
          atval: "1",
          ttype: o
        }, {
          input: "\\{",
          tag: "mo",
          output: "{",
          atval: "1",
          ttype: o
        }, {
          input: "\\lbrace",
          tag: "mo",
          output: "{",
          atval: "1",
          ttype: o
        }, {
          input: "\\langle",
          tag: "mo",
          output: "\u2329",
          atval: "1",
          ttype: o
        }, {
          input: "\\lfloor",
          tag: "mo",
          output: "\u230a",
          atval: "1",
          ttype: o
        }, {
          input: "\\lceil",
          tag: "mo",
          output: "\u2308",
          atval: "1",
          ttype: o
        }, {
          input: ")",
          tag: "mo",
          output: ")",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "]",
          tag: "mo",
          output: "]",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\rbrack",
          tag: "mo",
          output: "]",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\}",
          tag: "mo",
          output: "}",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\rbrace",
          tag: "mo",
          output: "}",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\rangle",
          tag: "mo",
          output: "\u232a",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\rfloor",
          tag: "mo",
          output: "\u230b",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "\\rceil",
          tag: "mo",
          output: "\u2309",
          rtag: "mi",
          atval: "1",
          ttype: o
        }, {
          input: "|",
          tag: "mo",
          output: "|",
          ttype: K
        }, {
          input: "\\|",
          tag: "mo",
          output: "\u2225",
          atval: "1",
          ttype: o
        }, {
          input: "\\vert",
          tag: "mo",
          output: "\u2223",
          atval: "1",
          ttype: o
        }, {
          input: "\\Vert",
          tag: "mo",
          output: "\u2225",
          atval: "1",
          ttype: o
        }, {
          input: "\\mid",
          tag: "mo",
          output: "\u2223",
          atval: "1",
          ttype: o
        }, {
          input: "\\parallel",
          tag: "mo",
          output: "\u2225",
          atval: "1",
          ttype: o
        }, {
          input: "/",
          tag: "mo",
          output: "/",
          atval: "1.01",
          ttype: o
        }, {
          input: "\\backslash",
          tag: "mo",
          output: "\u2216",
          atval: "1",
          ttype: o
        }, {
          input: "\\setminus",
          tag: "mo",
          output: "\\",
          ttype: b
        }, {
          input: "\\!",
          tag: "mspace",
          atname: "width",
          atval: "-0.167em",
          ttype: x
        }, {
          input: "\\,",
          tag: "mspace",
          atname: "width",
          atval: "0.167em",
          ttype: x
        }, {
          input: "\\>",
          tag: "mspace",
          atname: "width",
          atval: "0.222em",
          ttype: x
        }, {
          input: "\\:",
          tag: "mspace",
          atname: "width",
          atval: "0.222em",
          ttype: x
        }, {
          input: "\\;",
          tag: "mspace",
          atname: "width",
          atval: "0.278em",
          ttype: x
        }, {
          input: "~",
          tag: "mspace",
          atname: "width",
          atval: "0.333em",
          ttype: x
        }, {
          input: "'",
          tag: "mo",
          output: "\u02b9",
          ttype: b
        }, {
          input: "''",
          tag: "mo",
          output: "\u02ba",
          ttype: b
        }, {
          input: "'''",
          tag: "mo",
          output: "\u2034",
          ttype: b
        }, {
          input: "''''",
          tag: "mo",
          output: "\u2057",
          ttype: b
        }, {
          input: "\\ldots",
          tag: "mo",
          output: "\u2026",
          ttype: b
        }, {
          input: "\\cdots",
          tag: "mo",
          output: "\u22ef",
          ttype: b
        }, {
          input: "\\vdots",
          tag: "mo",
          output: "\u22ee",
          ttype: b
        }, {
          input: "\\ddots",
          tag: "mo",
          output: "\u22f1",
          ttype: b
        }, {
          input: "\\emptyset",
          tag: "mo",
          output: "\u2205",
          ttype: b
        }, {
          input: "\\infty",
          tag: "mo",
          output: "\u221e",
          ttype: b
        }, {
          input: "\\triangle",
          tag: "mo",
          output: "\u25b3",
          ttype: b
        }, {
          input: "\\therefore",
          tag: "mo",
          output: "\u2234",
          ttype: b
        }, {
          input: "\\angle",
          tag: "mo",
          output: "\u2220",
          ttype: b
        }, {
          input: "\\inf",
          tag: "mo",
          output: "inf",
          ttype: m
        }, {
          input: "\\lim",
          tag: "mo",
          output: "lim",
          ttype: m
        }, {
          input: "\\liminf",
          tag: "mo",
          output: "liminf",
          ttype: m
        }, {
          input: "\\limsup",
          tag: "mo",
          output: "limsup",
          ttype: m
        }, {
          input: "\\max",
          tag: "mo",
          output: "max",
          ttype: m
        }, {
          input: "\\min",
          tag: "mo",
          output: "min",
          ttype: m
        }, {
          input: "\\sup",
          tag: "mo",
          output: "sup",
          ttype: m
        }, {
          input: "\\gets",
          tag: "mo",
          output: "\u2190",
          ttype: b
        }, {
          input: "\\leftarrow",
          tag: "mo",
          output: "\u2190",
          ttype: b
        }, {
          input: "\\to",
          tag: "mo",
          output: "\u2192",
          ttype: b
        }, {
          input: "\\rightarrow",
          tag: "mo",
          output: "\u2192",
          ttype: b
        }, {
          input: "\\leftrightarrow",
          tag: "mo",
          output: "\u2194",
          ttype: b
        }, {
          input: "\\uparrow",
          tag: "mo",
          output: "\u2191",
          ttype: b
        }, {
          input: "\\downarrow",
          tag: "mo",
          output: "\u2193",
          ttype: b
        }, {
          input: "\\updownarrow",
          tag: "mo",
          output: "\u2195",
          ttype: b
        }, {
          input: "\\rightharpoonup",
          tag: "mo",
          output: "\u21c0",
          ttype: b
        }, {
          input: "\\rightharpoondown",
          tag: "mo",
          output: "\u21c1",
          ttype: b
        }, {
          input: "\\Leftarrow",
          tag: "mo",
          output: "\u21d0",
          ttype: b
        }, {
          input: "\\Rightarrow",
          tag: "mo",
          output: "\u21d2",
          ttype: b
        }, {
          input: "\\Leftrightarrow",
          tag: "mo",
          output: "\u21d4",
          ttype: b
        }, {
          input: "\\iff",
          tag: "mo",
          output: "~\\Longleftrightarrow~",
          ttype: D
        }, {
          input: "\\Uparrow",
          tag: "mo",
          output: "\u21d1",
          ttype: b
        }, {
          input: "\\Downarrow",
          tag: "mo",
          output: "\u21d3",
          ttype: b
        }, {
          input: "\\Updownarrow",
          tag: "mo",
          output: "\u21d5",
          ttype: b
        }, {
          input: "\\mapsto",
          tag: "mo",
          output: "\u21a6",
          ttype: b
        }, {
          input: "\\longleftarrow",
          tag: "mo",
          output: "\u2190",
          ttype: y
        }, {
          input: "\\longrightarrow",
          tag: "mo",
          output: "\u2192",
          ttype: y
        }, {
          input: "\\longleftrightarrow",
          tag: "mo",
          output: "\u2194",
          ttype: y
        }, {
          input: "\\Longleftarrow",
          tag: "mo",
          output: "\u21d0",
          ttype: y
        }, {
          input: "\\Longrightarrow",
          tag: "mo",
          output: "\u21d2",
          ttype: y
        }, {
          input: "\\Longleftrightarrow",
          tag: "mo",
          output: "\u21d4",
          ttype: y
        }, {
          input: "\\longmapsto",
          tag: "mo",
          output: "\u21a6",
          ttype: b
        },
        {
          input: "\\sqrt",
          tag: "msqrt",
          output: "sqrt",
          ttype: k
        }, {
          input: "\\root",
          tag: "mroot",
          output: "root",
          ttype: C
        }, {
          input: "\\frac",
          tag: "mfrac",
          output: "/",
          ttype: C
        }, {
          input: "\\stackrel",
          tag: "mover",
          output: "stackrel",
          ttype: C
        }, {
          input: "\\underset",
          tag: "munder",
          output: "underset",
          ttype: C
        }, {
          input: "_",
          tag: "msub",
          output: "_",
          ttype: A
        }, {
          input: "^",
          tag: "msup",
          output: "^",
          ttype: A
        }, {
          input: "\\mathrm",
          tag: "mtext",
          output: "text",
          ttype: J
        }, {
          input: "\\mbox",
          tag: "mtext",
          output: "mbox",
          ttype: J
        }, {
          input: "\\atop",
          tag: "mfrac",
          output: "",
          ttype: A
        },
        {
          input: "\\choose",
          tag: "mfrac",
          output: "",
          ttype: A
        }, {
          input: "\\acute",
          tag: "mover",
          output: "\u00b4",
          ttype: k,
          acc: !0
        }, {
          input: "\\grave",
          tag: "mover",
          output: "`",
          ttype: k,
          acc: !0
        }, {
          input: "\\breve",
          tag: "mover",
          output: "\u02d8",
          ttype: k,
          acc: !0
        }, {
          input: "\\check",
          tag: "mover",
          output: "\u02c7",
          ttype: k,
          acc: !0
        }, {
          input: "\\dot",
          tag: "mover",
          output: ".",
          ttype: k,
          acc: !0
        }, {
          input: "\\ddot",
          tag: "mover",
          output: "..",
          ttype: k,
          acc: !0
        }, {
          input: "\\mathring",
          tag: "mover",
          output: "\u00b0",
          ttype: k,
          acc: !0
        }, {
          input: "\\vec",
          tag: "mover",
          output: "\u20d7",
          ttype: k,
          acc: !0
        }, {
          input: "\\overrightarrow",
          tag: "mover",
          output: "\u2192",
          ttype: k,
          acc: !0
        }, {
          input: "\\overleftarrow",
          tag: "mover",
          output: "\u2190",
          ttype: k,
          acc: !0
        }, {
          input: "\\hat",
          tag: "mover",
          output: "^",
          ttype: k,
          acc: !0
        }, {
          input: "\\widehat",
          tag: "mover",
          output: "\u0302",
          ttype: k,
          acc: !0
        }, {
          input: "\\tilde",
          tag: "mover",
          output: "~",
          ttype: k,
          acc: !0
        }, {
          input: "\\widetilde",
          tag: "mover",
          output: "\u02dc",
          ttype: k,
          acc: !0
        }, {
          input: "\\bar",
          tag: "mover",
          output: "\u203e",
          ttype: k,
          acc: !0
        }, {
          input: "\\overbrace",
          tag: "mover",
          output: "\ufe37",
          ttype: k,
          acc: !0
        }, {
          input: "\\overline",
          tag: "mover",
          output: "\u00af",
          ttype: k,
          acc: !0
        }, {
          input: "\\underbrace",
          tag: "munder",
          output: "\ufe38",
          ttype: k,
          acc: !0
        }, {
          input: "\\underline",
          tag: "munder",
          output: "\u00af",
          ttype: k,
          acc: !0
        }, {
          input: "\\underleftarrow",
          tag: "munder",
          output: "\u2190",
          ttype: k,
          acc: !0
        }, {
          input: "\\underrightarrow",
          tag: "munder",
          output: "\u2192",
          ttype: k,
          acc: !0
        }
      ],
      q = [];
    this.CanRender = hasMathPlayer || BrowserIS.isFirefox;
    var L = !1;
    this.ShowNote = function () {
      var c;
      if (L && (c = document.getElementById("MRSoftSetupGuide"))) {
        c.style.display =
          "";
        return
      }
      c = t("div");
      c.id = "MRSoftSetupGuide";
      c.style.cssText = "position: fixed; _position: absolute; z-index: 9999; opacity: 0.9; background-color: #7fb80e;vertical-align: middle; font-size: 14px; padding: 8px; bottom: 0; width: 99%;";
      c.innerHTML = '<a href="javascript:void(0)" onclick="this.parentNode.style.display=\'none\'"><img alt="\u5173\u95ed" style="float: right;" src="http://img.jyeoo.net/helper/mathplayer/close.png" /></a><div style="background: #F1F5FA;"><div style="margin:0 auto;font-size:16px;text-align:center;line-height:50px"><span>\u5982\u679c\u516c\u5f0f\u7b26\u53f7\u663e\u793a\u4e71\u7801\uff0c\u83c1\u4f18\u7f51\u5efa\u8bae\u60a8\u4e0b\u8f7d\u5e76\u5b89\u88c5\uff1a<a href="http://www.jyeoo.com/support/MPSetup" target="_blank" style="color:Black;"><u><b>\u516c\u5f0f\u663e\u793a\u8f6f\u4ef6<b></u></a></span></div></div>';
      document.body.appendChild(c);
      L = !0
    };
    this.ToMathML = function (c, a) {
      if (1 > q.length) {
        G.sort(r);
        for (i = 0; i < G.length; i++) q[i] = G[i].input;
        /[xyz]eoo\.[cn]|localhost|file:|127.0/ig.test(location) || (q.length = 0)
      }
      if ("string" != typeof c) return null;
      var b, d, f, k;
      f = F(c);
      p("mstyle");
      d = p("mstyle");
      k = a || h;
      for (var l in k) b = k[l], "string" == typeof b && "" != b.replace(/^\s+/g, "") && d.setAttribute(l, b);
      d.appendChild(v(f, !1, !1)[0]);
      d = e("math", d);
      d.setAttribute("latex", c.replace(/^\$|\$$/g, ""));
      d.setAttribute("title", d.getAttribute("latex"));
      return d
    };
    this.ServerParse = function (c) {
      var a = F(c),
        a = a.replace(/\u00d7/g, "\\times "),
        a = a.replace(/\u00b1/g, "\\pm "),
        a = a.replace(/[\uff1e>]/ig, "\\gt "),
        a = a.replace(/[\uff1c<]/ig, "\\lt "),
        a = a.replace(/\u00f7/ig, "\\div "),
        a = a.replace(/\u03c0/ig, "\\pi "),
        a = a.replace(/\u03b1/ig, "\\alpha "),
        a = a.replace(/\u03b2/ig, "\\beta "),
        a = a.replace(/\u03b3/ig, "\\gamma "),
        a = a.replace(/\uff0c/ig, ","),
        a = a.replace(/\uff1b/ig, ";"),
        a = a.replace(/\uff1a/ig, ":"),
        a = a.replace(/[\u2022\uff0e]/ig, "\\cdot "),
        a = a.replace(/\u2460/g,
          "(1)"),
        a = a.replace(/\u2461/g, "(2)"),
        a = a.replace(/\u2462/g, "(3)"),
        a = a.replace(/\u00b0/g, "^o"),
        a = a.replace(/[\u22ef\u2026]/g, "..."),
        a = a.replace(/\u22f1/g, "\\ddots"),
        a = a.replace(/\u2032/g, "'"),
        a = a.replace(/\u2033/g, "''"),
        a = a.replace(/\u3001/g, ","),
        a = a.replace(/\u2265/g, "\\ge "),
        a = a.replace(/\u2264/g, "\\le "),
        a = a.replace(/\u2260/g, "\\ne "),
        a = a.replace(/\u2248/g, "\\approx "),
        a = a.replace(/\u2235/g, "\\because "),
        a = a.replace(/\u2234/g, "\\therefore "),
        a = a.replace(/\u2220/g, "\\angle "),
        a = a.replace(/\\root\s*{([^{]+?)}/ig,
          "\\sqrt[$1]"),
        b = t("img");
      b.setAttribute("latex", c.replace(/^\$|\$$/g, ""));
      b.setAttribute("title", "\u6570\u5b66\u516c\u5f0f\u2014\u5982\u663e\u793a\u4e71\u7801\uff0c\u8bf7\u5b89\u88c5\u516c\u5f0f\u663e\u793a\u8f6f\u4ef6MathPlayer\uff01");
      b.setAttribute("alt", "\u516c\u5f0f\u56fe\u7247");
      b.setAttribute("src", l[3] + encodeURIComponent(a));
      b.style.marginLeft = 0;
      b.style.marginRight = 0;
      b.style.verticalAlign = "middle";
      b.style.border = 0;
      return b
    };
    this.ParseDOM = function (b, a) {
      z(b, a);
      if (isIE && hasMathPlayer)
        for (var e =
            document.getElementsByTagName("math"), d = 0; d < e.length; d++) e[d].update()
    };
    this.Render = function (b, a) {
      if (w.CanRender) {
        if (z(b, function (b) {
            return w.ToMathML(b, a)
          }), isIE && hasMathPlayer)
          for (var e = document.getElementsByTagName("math"), d = 0; d < e.length; d++) e[d].update()
      } else {
        var f = !1;
        z(b, function (a) {
          f = !0;
          return w.ServerParse(a)
        });
        f && BrowserIS.isMSIE && w.ShowNote()
      }
    }
  },
  LatexRender, MathJye;
try {
  LatexRender = new LatexPageRender, MathJye = new htmlLatexRender
} catch (e$$12) {}
BrowserIS.isMSIE && (hasMathPlayer && document.write('<object id="mathplayer" classid="clsid:32F66A20-7614-11D4-BD11-00104BD3F987"></object>'), document.write('<?import namespace="m" implementation="#mathplayer"?>'));

function renderLatex(r) {
  try {
    MathJye.LayOut(r);
    LatexRender.Render(r, {
      color: "black",
      fontsize: "13px",
      fontfamily: "arial",
      displaystyle: "true"
    })
  } catch (t) {}
};